export default __webpack_public_path__ + "static/media/ped_bridge.5161e272.png";